<template>
  <div class="bgwithe">
    <!-- class="bgwithe" -->
    <el-container>
      <el-main>
        <div class="box">
          <!-- 按钮组 -->
          <div class="left">
            <div v-for="(item,index) in msg" :key="index" class="leftItem" @click="ChangClick(index)" :class="{liBackground:clickIndex==index}">
              <div>{{ item.title }}</div>
            </div>
            <div class="tishi" style="padding-top: 5%;margin:0px 20px;">
              <span class="lefttishi">温馨提示：</span><br />
              <span>1.请确保批量充值号码为<span class="bto">自己名下卡</span></span><br />
              <span>2.请确保批量充值号码为<span class="bto">相同的套餐包体</span></span><br />
              <span>3.请确保当前账户有<span class="bto">足够余额</span>可以批量充值</span><br />
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="right">
            <el-form label-width="100px" v-show="clickIndex==0">
              <el-form-item label="类型：">
                <el-button disabled>设备</el-button>
              </el-form-item>
              <el-form-item label="设备号码：">
                <el-input type="textarea" name="content" id="content" rows="15" v-model="iccids" placeholder="多个卡号以逗号分开" @change="getPacketName()">
                </el-input>
              </el-form-item>
              <el-form-item ref="secpag"  label="套餐包：">
                <el-select  @change="selectPacket()"  filterable allow-create default-first-option v-model="packetId" placeholder="请选择套餐包">
                  <el-option    v-for="(i,d) in packets" :key="d" :label="i.packetName" :value="i.packetId">
                  </el-option>
                </el-select>
                <el-select  filterable allow-create default-first-option v-model="monthType" placeholder="选择生效类型">
                  <el-option  v-for="(item,index) in startType" :key="index" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="danger" @click.native="validatePassword()" :disabled="btnStatus" style="margin-left:10px;">
                  批量加包
                </el-button>
              </el-form-item>
              <el-form-item label="是否分润">
                <el-radio v-model="radio" label="0" >否</el-radio>
                <el-radio v-model="radio" label="1">是</el-radio>
              </el-form-item>
            </el-form>

          </div>
        </div>


        <!-- 以前的 -->
        <el-dialog v-loading="loading" :close-on-click-modal="false" data-height="700" title="套餐包详情" :visible.sync="diavalpactage" class="class_dialog_hospital" width="35%">
          <el-form label-width="120px" style="display:flex;justify-content: space-between;flex-wrap: wrap;">
            <el-form-item label="已选择套餐包：">
              <el-input v-model="CardPacket.packetName" disabled />
            </el-form-item>
            <el-form-item label="套餐包流量：">
              <el-input v-model="CardPacket.packetFlow" disabled />
            </el-form-item>
            <el-form-item label="套餐包价格：">
              <el-input v-model="CardPacket.packetCost" disabled />
            </el-form-item>
            <el-form-item label="套餐包有效期：">
              <el-input v-model="CardPacket.packetValidTime" disabled style="width:30%;" />
              <el-input v-model="CardPacket.packetValidName" disabled style="width:20%;" />
            </el-form-item>
          </el-form>
        </el-dialog>


        <el-dialog v-if="diavalidatePassword" v-loading="loading" :close-on-click-modal="false" data-height="700"
                   title="批量加包" :visible.sync="diavalidatePassword" class="class_dialog_hospital" width="50%">
          <el-row>
            <el-col><span class="leftstyle" style="font-size: 14px">套餐包名称：<span class="rightstyle">{{CardPacket.packetName}}</span></span></el-col>
            <el-col><span class="leftstyle" style="font-size: 14px">批量充值总数：<span class="rightstyle">{{batchCount}} </span>条</span></el-col>
            <el-col><span class="leftstyle" style="font-size: 14px">批量充值总金额：<span class="rightstyle">{{batchCountPrice}} </span>元</span>
            </el-col>
            <el-col><span class="leftstyle" style="font-size: 14px">生效类型：{{monthType==='month'?'本月':'次月'}}</span></el-col>
            <el-col><span class="leftstyle" style="color: red;font-size: 14px">温馨提示：立即执行，此操作不可逆，到账之后即无法退款，请务必仔细核对</span>
            </el-col>
          </el-row>
          <div class="pl" style="width: 100%; display: flex;margin: 10px 0px 20px 0px;">
            <div>
              <el-input v-model="password" placeholder="请输入账户密码" style="width:95%;" />
            </div>
            <div style="margin-left:10px;">
              <el-button :disabled="dis" type="primary" @click.native="recharge()">
                确定加包
              </el-button>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>

  </div>
</template>

<script>
  import Pagination from '../../components/pagination'
  import check from '../../static/js/check'
  import tools from '../../utils/tools'

  export default {
    name: 'batchRecharge',
    components: { Pagination },
    mounted: function () {
      let _this = this
      _this.loginUser = JSON.parse(sessionStorage.getItem('loginUser'))
      _this.agentid = _this.loginUser.agentId
      _this.userId = _this.loginUser.id
      _this.impot()
      _this.dis = false
    },
    data() {
      return {
        batchCount:0,
        batchCountPrice:0.00,
        radio:"0",
        monthType: '-',
        startType:[
          {name:'选择生效类型',value: '-'},
          {name:'当月',value:'month'},
        ],
        packet:{},
        loading: false,
        new_nextStatus_option: [
          { label: '当月生效', value: '0' },
          { label: '次月生效', value: '1' }
        ],
        dis: false,
        Is_Open: '0',
        Is_Stop: '1',

        packages: [],
        options: [],
        diaVisImport: false,
        limitNum: 1,
        iccids: '',
        type: '',
        packetId: '',
        packets: [],
        password: '',
        prestorePrice: '',
        diavalidatePassword: false,
        month: false,
        packetInfo: false,
        nextStatus: '',
        CardPacket: {
          packetFlow: '',
          packetCost: '',
          packetValidTime: '',
          packetName: '',
          packetValidName: ''
        },
        agentid: '',
        new_nextStatus: '0',
        new_password: '',
        userId: '',
        btnStatus: false,
        diavalpactage: false,
        digUpClick: false,
        msg: [
          { id: '1', title: '批量设备充值' },
        ],
        clickIndex: 0
      }
    },
    methods: {
      async getPacketName() {
        let _this = this
        _this.iccids = _this.iccids.trim()
        let reg= /^[0-9a-zA-Z]+(,[0-9a-zA-Z]+)*$/
        if(!reg.test(_this.iccids)){
          _this.$alert('包含特殊字符','查询失败')
          return false
        }
        const {data:res}=await _this.$ajax.post(process.env.VUE_APP_SERVER + '/device/device-info/batchDeviceBag', {
          deviceIccids: _this.iccids
        })
        if(res.code!=="0"){
          _this.$alert(res.msg,'查询失败')
          return false
        }
        _this.packets = res.data.data
      },

      //根据包体选择显示包的详细信息
      async selectPacket() {
        let _this = this
        if (_this.packetId !== '') {
          _this.monthType=''
        const {data:res}= await _this.$ajax.get(process.env.VUE_APP_SERVER + '/device/device-info/getBagInfo', {
                    params: {
                      packetId: _this.packetId,
                      agentId: _this.packets[0].agentId
                    }
                  })
        if(res.code!=='0'){
          _this.$alert(res.msg,'获取失败')
          return false
        }
        _this.CardPacket=res.data.data

        if(_this.CardPacket.packetValidName==='天'){
          _this.startType=[
            {"name":"选择生效类型","value":"-"},
            {"name":"当月","value":"month"},
          ]
        }else{
          _this.startType=[
            {"name":"选择生效类型","value":"-"},
            {"name":"当月","value":"month"},
            {"name":"次月","value":"next"},
          ]
        }
        _this.diavalpactage=true
        }
      },
      //输入密码
      validatePassword() {
        let _this = this
        if (_this.iccids === '' || _this.iccids === undefined) {
          _this.$alert('请先输入要充值的设备号','失败')
          return false
        }
        if (_this.CardPacket === '' || _this.CardPacket === undefined) {
          _this.$alert('请先选择对应套餐包','失败')
          return false
        }
        if(_this.monthType===''||_this.monthType===undefined){
          _this.$alert('请先选择生效类型','失败')
          return false
        }

        let count=1
        _this.iccids.replaceAll("，",",").split(",").map((item,index)=>{
          if(item!==''){
            count += index
          }
        })
        if(count>5000){
          _this.$alert('最大输入个数5000','失败')
          return false
        }
        _this.batchCount=count
        _this.batchCountPrice = _this.batchCount * _this.CardPacket.packetCost
        _this.diavalidatePassword = true
      },

      //批量加包确定加包
      recharge() {
        let _this = this
        _this.dis = true
        if (_this.nextStatus === '' || _this.nextStatus === null) {
          _this.nextStatus = 0
        }
        if (_this.password === '' || _this.password === null) {
          _this.$swal('请输入账户密码！')
          return false
        }
        _this.btnstatus = true
        _this.loading = true
        _this.$ajax
                .post(process.env.VUE_APP_SERVER + '/device/device-info/device-recharge', {
                  packetId: _this.packetId,
                  iccids: _this.iccids,
                  monthType: _this.monthType,
                  radio:_this.radio,
                  password: _this.password
                })
                .then(res => {
                  if (res.data.code === '0') {
                    _this.$alert(res.data.data,'成功')
                    _this.diavalidatePassword = false
                  } else {
                    _this.$alert(res.msg,'失败')
                    _this.diavalidatePassword = false
                  }
                  _this.loading = false
                })
                .catch(err => {
                  _this.$alert(err + '网络异常')
                  _this.diavalidatePassword = false
                })
      }
    }
  }
</script>

<style scoped>

  textarea {
    border: 1px solid;
  }

  #dd {
    margin-left: 0% !important;
    display: inline;
  }

  .my_checkbox {
    margin-right: 15px;
  }

  .my_checkbox__inner {
    border: none;
  }
  /deep/.el-textarea {
    width: 80%;
  }

  /* --------------------------弹窗样式------------------------------ */
  /*标题样式*/
  /deep/.class_dialog_hospital .el-dialog__title {
    font-size: 15px;
    margin-left: 15px;
  }

  /*头区样式*/
  /deep/.class_dialog_hospital .el-dialog__header {
    height: 50px;
    background: #e6e6e6;
    padding: 15px 0 4px 10px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }

  /*头区退出按钮样式*/
  /deep/.class_dialog_hospital .el-dialog__headerbtn {
    top: 14px;
    right: 20px;
    font-size: 16px;
  }

  /*对话框区*/
  /deep/.class_dialog_hospital .el-dialog {
    border: 1px solid #dcdfe6;
    box-shadow: 0 0 4px #e6e6e6;
    border-radius: 9px;
    padding: 0;
  }

  /*内容区*/
  /deep/.class_dialog_hospital .el-dialog__body {
    padding: 0;
    padding-top: 20px;
    margin: 0px 20px;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #333;
    font-weight: 700;
  }
  /*脚区*/
  /deep/.class_dialog_hospital .el-dialog__footer {
    border-top: 2px solid #e8eaec;
    padding: 16px;
  }
  .box_left {
    width: 48%;
    background-color: #fff;
    padding: 20px 0px;
    box-sizing: border-box;
    border-radius: 5px;
  }
  .left_item {
    display: flex;
    justify-content: space-around;
  }
  .leftstyle {
    font-size: 17px;
    font-weight: 700;
  }
  .rightstyle {
    font-size: 20px;
    color: red;
  }
  .mode {
    font-size: 25px;
    font-weight: 700;
    padding-left: 20px;
  }
  .border {
    width: 100%;
    height: 2px;
    background-color: #f5f5f5;
    margin: 15px 0px;
  }
  .text-area {
    width: 100%;
    margin: 20px 0px;
    text-align: center;
  }
  .box {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
  .upload-demo {
    text-align: center;
    margin-bottom: 20px;
  }
  .tishi {
    font-size: 13px;
  }
  .lefttishi {
    font-size: 15px;
    font-weight: 700;
    color: red;
  }
  .bto {
    font-weight: 700;
    color: red;
  }
  /* --------------- */
  .left {
    width: 30%;
    display: flex;
    flex-direction: column; /* background-color: red; */
    align-items: center;
  }
  .leftItem {
    width: 50%;
    border: 1px solid #dcdfe6;
    margin-top: 10px;
    text-align: center;
    border-radius: 5px;
    padding: 4px 0px;
  }
  .right {
    width: 66%;
    padding: 20px;
    padding-left: 7%;
    margin-left: 2%;
    border: 1px dashed #dcdfe6;
    border-radius: 5px;
  }
  .liBackground {
    background-color: #f5f5f5;
    color: #40a9ff;
    border: 1px solid #6052ff;
  }
</style>
